/**
 * Untouched templates OpenClaw and Hermes seed, so they are not imported as if the user
 * wrote them (a bot would otherwise follow OpenClaw's first-run ritual, or say it is Hermes).
 *
 * A file is a default only when its whole text, whitespace collapsed (and, for OpenClaw,
 * front matter removed as OpenClaw does when seeding), exactly matches a published version;
 * any edit makes it the user's own. `scripts/agent-import-defaults.mjs` rebuilds the tables.
 */

const versions = (keys: readonly string[]): ReadonlySet<string> => new Set(keys);

// Generated by `node scripts/agent-import-defaults.mjs <openclaw-checkout> <hermes-agent-checkout>`
// (OpenClaw with its full history); each comment lists the OpenClaw commits with that text.
const OPENCLAW_DEFAULTS: Record<string, ReadonlySet<string>> = {
  "SOUL.md": versions([
    "1f9d4935:1656", // 4e1fe881953777b52ddca9907a0fc6131fa3ebc1 db4d0b8e7519c17d9a82052242452c52b2d4d341
    "66fe660b:231", // 590f3d0e8f285d02e594cd718bfe9350ea5ee267
    "82870d3:1786", // 2fb9c7e3e586044467f360edf8d8f5170f1c60f5
    "873a4faf:1498", // f7d7148cf0477a62e05de733bb4484ae674a4697
    "a5c8dc95:1549", // f748b91a8e582d454272d9c4d3c6ec7feb490dd1
    "af6fe3ed:745", // cdb2a0736ab6dc8d1c972e0327172c9e0643bb42
    "cb9241e4:1729", // 2777b089b53f0b78baebd54f8a0e893a9d4f4285 b59ce0903c2386f3f43d6ff48ec63b5115407c11 c5c163d07883f418c8dd020d12ddb09639168c83
    "df5bcffe:1512", // a219fa50a0a99799440898037d7553a8f74e24ff
    "df78b67:1656", // 8cab78abbc8dec493ae0fc63f9828636845eb1f8 a172ff9ed27a7549e57df551080b86462e58835c
    "e80e4a50:584", // cfd3efb6e767bcab8bbc2617913be2259e953bbb
  ]),
  "AGENTS.md": versions([
    "137b71c6:7781", // 834663dfef8d0431d7b82e7243535dcf165843c1
    "1caa69dc:4199", // 03c15995447fffeeb988938b407de071f98d0ac3
    "2070d0:6398", // 9ffea23f31ca1df5183b25668f8f814bee0fb34e
    "22c4726a:1678", // 4e1fe881953777b52ddca9907a0fc6131fa3ebc1
    "23f38c2a:8018", // 99a1107b61915bc28f226f2192359574c23e18e8
    "25e18af:7090", // cd7ebe9be15f7e14dbf472a8a6d0191aac7cf864
    "288c9b41:7744", // 496a5eb56f466e828e7f843a0a55dfc7fbe01199
    "3354b623:3289", // 7e4e9ecdeaf8849dbe464f31e50f4932c88904a3
    "370c9ded:5874", // 7d1fee70e76f2f634f1b41fca927ee663914183a
    "4c86afec:6252", // fe9a6eeab2980cd308e21080cc047a8347fd353a
    "4f98b85c:6698", // 8911a79d7f6194e184d38ce21b7c120552a85a2b db4d0b8e7519c17d9a82052242452c52b2d4d341
    "65334a9:3739", // c2a74d6d2a1bd57889ff4bb1d7e43621f49e3c63
    "6696556:7781", // 0a1f4f666a66846a67a103d10eeddb29d2ec422f 8cab78abbc8dec493ae0fc63f9828636845eb1f8 a172ff9ed27a7549e57df551080b86462e58835c
    "7064896c:6396", // a219fa50a0a99799440898037d7553a8f74e24ff
    "76cd4ca8:7777", // c7aec0660ea9075612c28d2e10eeb1829f0767d2
    "7e087f3e:6396", // 33f7b38f01f8ef2513630597307bbfb1d57c646b
    "8607cdd7:7249", // f43fac21c7641b4b6faa2105fb15e1e81c177dd0
    "8e3716be:8339", // 28630a9a6501dd3835d1cf5660eb5dd9c337d3bc
    "95da6431:2858", // ca806897c251cfbc333e11b4bdf71d18478783ae
    "962caa7d:7759", // 2fb9c7e3e586044467f360edf8d8f5170f1c60f5
    "96d9010a:5160", // 11a54959190fa8052c7302491ba255401167ea05
    "9a6d39a5:8622", // 58628604ab7805d6d0e16575e9ce1c61445e42a8
    "9c52be88:6319", // 61e385b33163b6f4dd8a5afb81ea3a71c3d886fe
    "a6ba2dd6:7107", // e882f7d207a9831d22d477c4536e9a45537a27f2
    "aa5757bc:7650", // 669db2968fcd0409210b7ab7787d53f607132e75
    "ab709141:799", // 590f3d0e8f285d02e594cd718bfe9350ea5ee267
    "b1265948:6267", // 31752aa9445cb4b16b14f0e3d5a0a822a25cd436
    "b3b00390:7786", // 96021a2b175b0d05f731e5175142c5fed964864d
    "b457dab3:7847", // e0fda55cf7f47662d0b2205de7c0d150ec661a89
    "b8fcb34f:7126", // f7d7148cf0477a62e05de733bb4484ae674a4697
    "b9642cf6:1772", // cfd3efb6e767bcab8bbc2617913be2259e953bbb
    "bad6ba44:7699", // 2777b089b53f0b78baebd54f8a0e893a9d4f4285 94340b959830b8d7dd70d486617963ad2999409c c5c163d07883f418c8dd020d12ddb09639168c83
    "bc9db760:8334", // 6f9da38401de104cc81f6057ce5dce711f218b9d
    "befed9d5:8245", // 9b7c95a0f0fecef33220f18e1c780be1d55c64e0
    "c3ecb2fe:8321", // 944cf08f94c334cff2b0fdf7e01187a9efa42715
    "c869319:7587", // a1262e15a3b5837e4b83d3862d8b459435514be7
    "cd69aee4:6678", // 7aa7fa79d020696f8b5db608e6a6287d631ab7c4
    "d25a1ade:7956", // f748b91a8e582d454272d9c4d3c6ec7feb490dd1
    "d435846:7870", // 6a1dedb00c29f84f6fd052f793a7813d9bcc9b83
    "e21d8010:4205", // bcdfe461d42426c2fc203be36e5d78a342593b32
    "ef6cae44:3942", // 424d31af1fc8c4dedd9bdcb322fadf1d72e39054
    "ff02ccbc:979", // 3876c1679ac9d935688a65502416a8c9ee97e391
  ]),
  "USER.md": versions([
    "2d4d6bd8:470", // 1bf9f237f719385517ba5f6c709875a18c1a53b6 2777b089b53f0b78baebd54f8a0e893a9d4f4285 c5c163d07883f418c8dd020d12ddb09639168c83 f1603314f03571180baf4049cf8cc78af18cb6e7
    "51eae270:470", // 4e1fe881953777b52ddca9907a0fc6131fa3ebc1 db4d0b8e7519c17d9a82052242452c52b2d4d341
    "5acbcfd1:528", // 2fb9c7e3e586044467f360edf8d8f5170f1c60f5
    "9eb15e46:108", // 3876c1679ac9d935688a65502416a8c9ee97e391
    "ab00c734:1125", // f748b91a8e582d454272d9c4d3c6ec7feb490dd1
    "d1a38684:860", // 28630a9a6501dd3835d1cf5660eb5dd9c337d3bc
  ]),
  "IDENTITY.md": versions([
    "1edd46fa:619", // 2777b089b53f0b78baebd54f8a0e893a9d4f4285 c5c163d07883f418c8dd020d12ddb09639168c83 c7aec0660ea9075612c28d2e10eeb1829f0767d2 f1603314f03571180baf4049cf8cc78af18cb6e7
    "41832300:619", // 9a7160786a7dbd21469fad73992158e415e4686e
    "4cfe096f:677", // 2fb9c7e3e586044467f360edf8d8f5170f1c60f5
    "6756052b:1382", // f748b91a8e582d454272d9c4d3c6ec7feb490dd1
    "6e534d55:474", // a2bea8e3666cc53e680046d27138b2521bbd5cac
    "7872e205:1437", // 3d24e87e64a5f9c16750c0f8c9ef96bd91bfa7b3
    "8a45e3c2:616", // a59ac5cf6f948b3277511698069d4dacb6c85b34 eba0625a708bb1eb21ce6200df32967a23efb89b
    "a1d6223f:67", // 3876c1679ac9d935688a65502416a8c9ee97e391
    "cba3e7cc:1259", // f7d7148cf0477a62e05de733bb4484ae674a4697
    "d556da7a:413", // 4e1fe881953777b52ddca9907a0fc6131fa3ebc1 db4d0b8e7519c17d9a82052242452c52b2d4d341
  ]),
};

// Hermes Agent hermes_cli/default_soul.py at 5141460529ad320140f9916be0b88ab1f0af563e: `DEFAULT_SOUL_MD`
// and the earlier auto-seeded texts it lists in `_LEGACY_TEMPLATE_SOULS`.
const HERMES_SOUL_DEFAULTS = versions([
  "26056aef:527",
  "69b6eff9:513",
  "6b620b40:315",
  "f1cdbf05:667",
  "f6791ed3:665",
]);

export function isOpenClawDefault(path: string, content: string): boolean {
  return OPENCLAW_DEFAULTS[path]?.has(fingerprint(withoutFrontmatter(content))) === true;
}

export function isHermesDefault(content: string): boolean {
  return HERMES_SOUL_DEFAULTS.has(fingerprint(content));
}

function withoutFrontmatter(content: string): string {
  const text = content.replace(/^\uFEFF/, "").replace(/\r\n?/g, "\n");
  return text.replace(/^---\n[\s\S]*?\n---\n/, "");
}

/** `<32-bit FNV-1a hex>:<UTF-8 length>` of the text with whitespace runs collapsed. */
function fingerprint(content: string): string {
  const bytes = new TextEncoder().encode(
    content
      .replace(/^\uFEFF/, "")
      .replace(/\s+/g, " ")
      .trim(),
  );
  let hash = 0x811c9dc5;
  for (const byte of bytes) {
    hash ^= byte;
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return `${hash.toString(16)}:${bytes.length}`;
}
